function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.956 10V.25a.25.25 0 01.25-.25h1.588a.25.25 0 01.25.25V10l4.303-4.304a.25.25 0 01.354 0l1.122 1.123a.25.25 0 010 .353L7.177 13.82a.25.25 0 01-.354 0L.177 7.172a.25.25 0 010-.353l1.122-1.123a.25.25 0 01.354 0L5.956 10zM14 17.75a.25.25 0 01-.25.25H.25a.25.25 0 01-.25-.25v-1.5A.25.25 0 01.25 16h13.5a.25.25 0 01.25.25v1.5z",
  fill: "#F15045"
});

var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none"
  }, props), _ref);
};

export default SvgDownload;